import { render, staticRenderFns } from "./detailedWaybillDispatch.vue?vue&type=template&id=614cfc5d"
import script from "./detailedWaybillDispatch.vue?vue&type=script&lang=js"
export * from "./detailedWaybillDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports